import { PublicParams } from './../../../../shared/utils/publicParams';
import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { xtwhUrls } from '@shared/urls/xtwhUrls';
import { generateFormData } from '@shared/utils/publicMethods';
import { NzMessageService } from 'ng-zorro-antd';
import * as publicMethods from './../../../../shared/utils/publicMethods';

@Component({
    selector: 'app-safety',
    templateUrl: './safety.component.html',
})
export class SafetyComponent {
    @Input() public userInfo: any;
    validateForm: FormGroup;
    spinning: boolean;
    confirmPasswordVisible = false;

    confirmValidator = (control: FormControl): { [s: string]: boolean } => {
        if (!control.value) {
            return { error: true, required: true };
        } else if (control.value !== this.validateForm.controls.newPassword.value) {
            return { confirm: true, error: true };
        }
        return {};
    };

    constructor(private fb: FormBuilder, private http: HttpClient, private msg: NzMessageService) {
        this.validateForm = this.fb.group({
            userName: [''],
            code: [''],
            oldPassword: ['', Validators.required],
            newPassword: ['', Validators.required],
            againPassword: ['', [this.confirmValidator]],
        });
    }

    updatePassword() {
        this.spinning = true;
        this.http
            .post(
                xtwhUrls.userConfig.updPass,
                generateFormData({
                    oldPass: publicMethods.encrypt(this.userInfo.oldPassword, PublicParams.salt),
                    newPwd: publicMethods.encrypt(this.userInfo.newPassword, PublicParams.salt),
                    //   oldPass: Md5.hashStr(this.userInfo.oldPassword),
                    // newPwd: Md5.hashStr(this.userInfo.newPassword),
                }),
            )
            .subscribe((res: any) => {
                this.spinning = false;
                if (res.err_code === 2000) {
                    this.msg.success(res.err_msg);
                } else {
                    this.msg.error(res.err_msg);
                }
            });
    }
}
